import { splitEvery } from 'ramda';

import { UploadTarget } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';

import { MAX_UPLOADING_COUNT } from '../model';

export const divideTargetsIntoChunks = (
  uploadTargets: UploadTarget[],
): UploadTarget[][] => splitEvery(MAX_UPLOADING_COUNT, uploadTargets);
